module.exports = __webpack_public_path__ + "static/media/earhear-1.a6c1a1f1.jpg";